enum UserStatus {
    LOGIN_CREATED = "LoginCreated",
    ACCESS_REQUESTED = "AccessRequested",
    DENIED_ACCESS = "DeniedAccess",
    ACTIVE = "Active",
    INACTIVE = "Inactive"
}
  
export default UserStatus;